import { render, staticRenderFns } from "./DebtorAgingReportView.vue?vue&type=template&id=80eb0ec0&scoped=true"
import script from "./DebtorAgingReportView.vue?vue&type=script&lang=js"
export * from "./DebtorAgingReportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80eb0ec0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80eb0ec0')) {
      api.createRecord('80eb0ec0', component.options)
    } else {
      api.reload('80eb0ec0', component.options)
    }
    module.hot.accept("./DebtorAgingReportView.vue?vue&type=template&id=80eb0ec0&scoped=true", function () {
      api.rerender('80eb0ec0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/debtoragingreport/DebtorAgingReportView.vue"
export default component.exports